import React, { useCallback, useMemo } from 'react';
import { Select } from './Select';

interface Props {
  label?: string | React.ReactNode;
  onChange?: (value: string) => void;
  value?: string;
  containerClass?: string;
  error?: string;
  noMargin?: boolean;
  noBottomMargin?: boolean;
  rightAction?: React.ReactNode;
  options?: Array<{ label: string; value: string | number } | string | number>;
  i18nKeyPrefix?: string;
  placeholder?: string;
  name?: string;
  isSearchable?: boolean;
  disabled?: boolean;
}

export const TextSelect = ({
  onChange,
  options,
  placeholder,
  ...rest
}: Props) => {
  const _onChange = useCallback(
    (option: { value: string | number }) => {
      if (onChange) {
        onChange(`${option.value}`);
      }
    },
    [onChange],
  );

  const _options = useMemo(() => {
    if (!options) {
      return options;
    }
    return options.map((option) => {
      if (typeof option !== 'object') {
        return `${option}`;
      }
      return {
        ...option,
        value: `${option.value}`,
      };
    });
  }, [options]);

  return (
    <Select
      {...rest}
      placeholder={placeholder}
      onChange={onChange ? _onChange : undefined}
      options={_options}
    />
  );
};
